import React from 'react';

/**
 * @typedef {Object} ImageModel
 * @property {string} defaultImageSrc
 * @property {string} defaultFocusPoint
 * @property {string} overrideImageSrc
 * @property {string} overrideFocusPoint
 * @property {string} alt
 */

/**
 * @param {ImageModel} model
 * @param {string} [className]
 * @param {number} [xxlarge]
 * @param {number} [xlarge]
 * @param {number} [small]
 * @param {number} [large]
 * @param {number} [medium]
 * @param {number} [aspectRatio]
 * @returns {JSX.Element}
 */
export function Picture({model, className, xxlarge, xlarge, large = 1168, medium = 767, small = 479, aspectRatio}) {
    const pictureWidth = small;
    const baseHeight = aspectRatio ? Math.round(pictureWidth / aspectRatio) : pictureWidth;
    return (
        <picture className={className}>
            {xxlarge && <SourceSet model={model} breakpoint={1600} width={xxlarge} aspectRatio={aspectRatio} />}
            {xlarge && <SourceSet model={model} breakpoint={1280} width={xlarge} aspectRatio={aspectRatio} />}
            <SourceSet model={model} breakpoint={768} width={large} aspectRatio={aspectRatio} />

            <SourceSet model={model} breakpoint={480} width={medium} aspectRatio={aspectRatio} />

            <SourceSet model={model} breakpoint={320} width={small} aspectRatio={aspectRatio} />

            <img
                src={`${model.defaultImageSrc}?w=${pictureWidth}&h=${baseHeight}&fit=fill&q=80&fm=jpg&f=${model.defaultFocusPoint}`}
                srcSet={`${model.defaultImageSrc}?w=${pictureWidth}&h=${baseHeight}&fit=fill&q=80&fm=webp&f=${model.defaultFocusPoint} 1x, ${model.defaultImageSrc}?w=${pictureWidth * 2}&h=${baseHeight * 2}&fit=fill&q=80&fm=webp&f=${model.defaultFocusPoint} 2x`}
                alt={model.alt}
                width={pictureWidth}
                height={baseHeight}
            />
        </picture>
    );
}

/**
 * @param {ImageModel} model
 * @param {number} breakpoint
 * @param {number} width
 * @param {number} [aspectRatio]
 * */

function SourceSet({model, width, breakpoint, aspectRatio}) {
    const src = width >= 768 ? model.overrideImageSrc : model.defaultImageSrc;
    const focusPoint = width >= 768 ? model.overrideFocusPoint : model.defaultFocusPoint;
    const height = aspectRatio
        ? Math.round(width / aspectRatio)
        : width >= 768
          ? Math.round((width / 1168) * 572)
          : width;
    return (
        <source
            srcSet={`${src}?w=${width}&h=${height}&fit=fill&q=80&fm=webp&f=${focusPoint} 1x, ${src}?w=${width * 2}&h=${height * 2}&fit=fill&q=80&fm=webp&f=${focusPoint} 2x`}
            media={`(min-width: ${breakpoint}px)`}
            type="image/webp"
        />
    );
}
